import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import { subscribe, unsubscribe } from './VideoUploadManager';

const url = process.env.REACT_APP_API_URL;

interface UploadStatus {
  uploadId: string;
  progress: number;
  status: string;
  error?: string;
}

// export function useVideoUploadHub(uploadId: string) {
//   const [uploadStatus, setUploadStatus] = useState<UploadStatus | null>(null);

//   useEffect(() => {
//     if (!uploadId) return;

//     const connection: HubConnection = new HubConnectionBuilder()
//       .withUrl(`${url}/hubs/video-upload`)
//       .withAutomaticReconnect()
//       .build();

//     connection.start()
//       .then(() => {
//         console.log('Går med i video upload grupp:', uploadId);
//         connection.invoke('JoinUploadGroup', uploadId);
//       })
//       .catch(console.error);

//     connection.on('UploadUpdated', (data: UploadStatus) => {
//       console.log('Upload callback:', data);

//       if (data.uploadId === uploadId) {
//         setUploadStatus(data);
//       }
//     });

//     return () => {
//       connection.stop();
//     };
//   }, [uploadId]);

//   return uploadStatus;
// }
export function useVideoUploadHub(uploadId: string) {
  const [status, setStatus] = useState<UploadStatus | null>(null);

  useEffect(() => {
    if (!uploadId) return;

    subscribe(uploadId, (data) => {
      setStatus(data);
    });

    return () => {
      unsubscribe(uploadId);
    };

  }, [uploadId]);

  return status;
}
